import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import { defaultStorage, sessionStorage } from 'aws-amplify/utils';

const AUTH_PERSISTENCE_KEY = 'auth_persistence';

export type AuthPersistence = 'local' | 'session';

export const getAuthPersistence = (): AuthPersistence => {
  const storedValue = localStorage.getItem(AUTH_PERSISTENCE_KEY);
  return storedValue === 'local' ? 'local' : 'session';
};

export const applyAuthPersistence = (mode: AuthPersistence): void => {
  cognitoUserPoolsTokenProvider.setKeyValueStorage(mode === 'local' ? defaultStorage : sessionStorage);
};

export const setAuthPersistence = (mode: AuthPersistence): void => {
  localStorage.setItem(AUTH_PERSISTENCE_KEY, mode);
  applyAuthPersistence(mode);
};
